<template>
  <error-page
    textSubtitle="No estás autorizado para acceder."
    :listErrorComponent="listErrorComponents"
  />
</template>

<script>
import ErrorPage from './ErrorPage.vue';

export default {
  name: 'Error401',
  components: { ErrorPage },
  data () {
    return {
      listErrorComponents: [
        {
          id: 1,
          title: 'Pagina principal ',
          hrefLink: '#',
          target: '_top'
        }
      ]
    };
  }
};
</script>
